import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Leaf } from 'lucide-react';
export function CtaMid() {
  return <section className="relative w-full py-10 md:py-16 px-4 bg-green-900 overflow-hidden" data-id="element-92">
      <motion.div animate={{
      rotate: 360
    }} transition={{
      duration: 40,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute -right-10 -top-10 opacity-10 pointer-events-none" data-id="element-93">
        <Leaf className="w-32 h-32 text-lime-400" data-id="element-94" />
      </motion.div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-95">
        <motion.a href="#pricing" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="relative inline-flex items-center gap-2 bg-lime-500 hover:bg-lime-400 text-green-950 font-extrabold text-base md:text-lg px-6 py-3 md:px-8 md:py-4 rounded-xl shadow-[0_0_15px_rgba(132,204,22,0.3)] transition-all" data-id="element-96">
          👉 Quiero el sistema completo
          <ArrowRight className="w-5 h-5" data-id="element-97" />
          <Leaf className="absolute -top-2 -right-2 w-4 h-4 text-lime-400 rotate-45" data-id="element-98" />
        </motion.a>
        <p className="text-green-100 text-xs md:text-sm mt-4 font-medium" data-id="element-99">
          Acceso inmediato · Descarga digital · Empezá hoy
        </p>
      </div>
    </section>;
}